import { Component, OnInit } from '@angular/core'
import { Observable } from 'rxjs'
import {
  CurrentProductService,
  LaunchDialogService,
} from '@spartacus/storefront'
import {
  AuthService,
  GlobalMessageService,
  GlobalMessageType,
} from '@spartacus/core'
import { PDPService } from '../services/pdp.services'
import { Actions, ofType } from '@ngrx/effects'
import { take } from 'rxjs/operators'
import { ActivatedRoute } from '@angular/router'
import { ActiveCartFacade, MultiCartFacade } from '@spartacus/cart/base/root'
import { CartActions } from '@spartacus/cart/base/core'
import { userRoles } from '../../../models/user.model'
import { Product } from '../../../models/product.model'
import { CommonService } from '../../../shared/services/common.service'
import { VS_LAUNCH_CALLER } from '../../config/dialog.config'

@Component({
  standalone: false,
  selector: 'vs-bom-list',
  templateUrl: './bom-list.component.html',
  styleUrls: ['./bom-list.component.scss'],
})
export class BomListComponent implements OnInit {
  product$: Observable<Product | any> = this.currentProductService.getProduct()
  loggedIn: boolean
  public userRoles = userRoles
  product: Product
  increment = false
  cartId: string
  defaultSalesArea
  id: any
  constructor(
    public currentProductService: CurrentProductService,
    public auth: AuthService,
    public activeCartService: ActiveCartFacade,
    private launchDialogService: LaunchDialogService,
    public pdpService: PDPService,
    private activatedRoute: ActivatedRoute,
    public commonService: CommonService,
    public multiCartService: MultiCartFacade,
    public globalMessageService: GlobalMessageService,
    private actions$: Actions
  ) {}
  allChecked = false
  checked = false
  public bomProductList = []
  ngOnInit(): void {
    // this.activatedRoute.paramMap.subscribe((value:any) =>{
    //   this.id =value.params.productCode});
    //   this.product$ = this.pdpService.getProduct(this.id);
    this.activeCartService.getActiveCartId().subscribe((res) => {
      this.cartId = res
    })

    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        if (success) {
          this.loggedIn = true
        } else {
          this.loggedIn = false
        }
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
    this.product$.subscribe((product: any) => {
      this.product = product
      if (this.product?.plantAvailableAt) {
        this.defaultSalesArea = this.product?.plantAvailableAt[0]
        this.product?.plantAvailableAt.forEach((element) => {
          if (element?.defaultPlant === true) {
            this.defaultSalesArea = element
          }
        })
      }
    })
  }
  setAll(checkedEvent) {
    this.allChecked = checkedEvent
    if (!this.allChecked) {
      this.bomProductList = []
    }
  }
  addBOMToCart() {
    if (!this.bomProductList.length) {
      this.globalMessageService.add(
        { key: 'pdp.selectAtleastOneProduct' },
        GlobalMessageType.MSG_TYPE_WARNING,
        5000
      )
      window.scrollTo(0, 0)
      return
    }
    let BOMPRoductList = []
    let i = 0
    for (i = 0; i < this.bomProductList.length; i++) {
      this.product.bomProductList.forEach((element) => {
        if (element.code === this.bomProductList[i].product.code) {
          BOMPRoductList.push(element)
        }
      })
    }
    this.pdpService
      .addBOMProductstoCart(this.bomProductList, this.cartId)
      .subscribe(
        (success) => {
          this.multiCartService.loadCart({
            userId: 'current',
            cartId: this.cartId,
            extraData: {
              active: true,
            },
          })
          this.actions$
            .pipe(ofType(CartActions.LOAD_CART_SUCCESS), take(1))
            .subscribe((r) => {
              this.openBOMCartModal(BOMPRoductList)
              // this.commonService.passBOMProducts(BOMPRoductList);
            })
        },
        (error) => {
          this.globalMessageService.add(
            { key: 'pdp.errorWhileAddingProducts' },
            GlobalMessageType.MSG_TYPE_ERROR,
            5000
          )
          window.scrollTo(0, 0)
        }
      )
  }
  addBOMQuote() {
    if (!this.bomProductList.length) {
      this.globalMessageService.add(
        { key: 'pdp.selectAtleastOneProduct' },
        GlobalMessageType.MSG_TYPE_WARNING,
        5000
      )
      window.scrollTo(0, 0)
      return
    }
    let BOMPRoductList = []
    let i = 0
    for (i = 0; i < this.bomProductList.length; i++) {
      this.product.bomProductList.forEach((element) => {
        if (element.code === this.bomProductList[i].product.code) {
          let obj = {
            brand: 'MASONEILAN',
            customerRequestedDate: Date.now(),
            partDescription: element.name,
            partNumber: element.code,
            productType: element?.productType,
            reasonforQuote: '',
            quantity: this.bomProductList[i].quantity || 1,
          }
          BOMPRoductList.push(obj)
        }
      })
    }
    let success = this.pdpService.addBOMProductstoQuoteCart(this.bomProductList)
    if (success) {
      this.commonService.passBOMProducts(BOMPRoductList)
      this.openBOMQuoteModal()
    } else {
      throw false
    }
    success = false
  }
  changeCheck() {
    this.allChecked = this.checked
  }
  getProduct(event) {
    if (event.checked) {
      var k = true
      for (var i = 0; i < this.bomProductList?.length; i++) {
        if (this.bomProductList[i]?.product?.code == event?.product?.code) {
          k = false
          this.bomProductList[i] = event
          // return;
        }
      }
      if (k == true) {
        this.bomProductList.push(event)
      }
    } else {
      this.checked = event.checked

      this.bomProductList.splice(this.bomProductList.indexOf(event.code), 1)
    }

    if (this.bomProductList.length === this.product.bomProductList.length) {
      this.checked = true
      this.allChecked = true
    }
  }
  openBOMCartModal(BOMPRoductList) {
    const componentdata = {
      BOMPRoductList: BOMPRoductList,
    }

    const addBomToCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ADD_BOM_TO_CART,
      undefined,
      undefined,
      componentdata
    )
    if (addBomToCartDialog) {
      addBomToCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
  openBOMQuoteModal() {
    const componentdata = {}

    const addBomToQuoteCartDialog = this.launchDialogService.openDialog(
      VS_LAUNCH_CALLER.ADD_BOM_TO_QUOTE_CART,
      undefined,
      undefined,
      componentdata
    )
    if (addBomToQuoteCartDialog) {
      addBomToQuoteCartDialog.pipe(take(1)).subscribe((value) => {})
      this.launchDialogService.dialogClose.subscribe((value) => {})
    }
  }
}
